import { Delete } from '@mui/icons-material';
import { CircularProgress, IconButton, Switch, Tooltip } from '@mui/material';
import React from 'react';
import useRTK from '../../../hooks/useRTK';
import { useDispatch } from 'react-redux';
import { useActivateSectorMutation, useDeactivateSectorMutation, useRemoveSectorMutation } from '../../../api/students/instituteProgramsAPI';
import { colors } from '../../../assets/utils/constants';
import { setSectors } from '../../../states/features/students/instituteProgramsSlice.js';

const SectorActions = ({ sector }) => {
    // ############ CONST ################
    const RTK = useRTK();
    const dispatch = useDispatch();

    // ############ RTK #################
    const [
        activateAction,
        {
            isLoading: activateLoading,
            isSuccess: activateSuccess,
            isError: activateIsError,
            error: activateError,
            data: activateData,
        },
    ] = useActivateSectorMutation();
    const [
        deactivateAction,
        {
            isLoading: deactivateLoading,
            isSuccess: deactivateSuccess,
            isError: deactivateIsError,
            error: deactivateError,
            data: deactivateData,
        },
    ] = useDeactivateSectorMutation();
    const [
        removeSector,
        {
            isLoading: removeLoading,
            isSuccess: removeSuccess,
            isError: removeIsError,
            error: removeError,
            data: removeData,
        },
    ] = useRemoveSectorMutation();
    // ############# useEffect ##################
    // => Action res
    const rtkActions = (data) => {
        dispatch(setSectors(data));
    };
    // => Activate
    RTK.useRTKResponse(
        activateSuccess,
        activateIsError,
        activateError,
        activateData,
        rtkActions,
    );
    // => Deactivate res
    RTK.useRTKResponse(
        deactivateSuccess,
        deactivateIsError,
        deactivateError,
        deactivateData,
        rtkActions,
    );
    // => Remove
    RTK.useRTKResponse(
        removeSuccess,
        removeIsError,
        removeError,
        removeData,
        rtkActions,
    );

    return (
        <>
            <Tooltip
                title={sector.status ? 'Deactivate sector' : 'Activate sector'}
                arrow
            >
                <IconButton
                    size="small"
                    disabled={
                        activateLoading || deactivateLoading ? true : false
                    }
                    onClick={() =>
                        sector.status
                            ? deactivateAction(sector.id)
                            : activateAction(sector.id)
                    }
                >
                    {activateLoading || deactivateLoading ? (
                        <>
                            <CircularProgress
                                size={20}
                                color="primary"
                                sx={{
                                    mx: 1.2,
                                    my: 0.3,
                                }}
                            />
                        </>
                    ) : (
                        <Switch
                            size="small"
                            color={sector.status ? 'success' : 'error'}
                            checked={sector.status ? true : false}
                        />
                    )}
                </IconButton>
            </Tooltip>
            <Tooltip title="Remove sector" arrow>
                <IconButton
                    size="small"
                    sx={{
                        background: `linear-gradient(180deg, ${colors.bgColor3}, ${colors.bgColor4})`,
                    }}
                    onClick={() => removeSector(sector.id)}
                    disabled={removeLoading ? true : false}
                >
                    {removeLoading ? (
                        <CircularProgress
                            size={15}
                            color="primary"
                            sx={{
                                mx: 0.5,
                            }}
                        />
                    ) : (
                        <Delete
                            sx={{
                                fontSize: 16,
                                mx: 0.5,
                            }}
                            color="error"
                        />
                    )}
                </IconButton>
            </Tooltip>
        </>
    );
};

export default SectorActions;
